import React from 'react';
import { Navigate, useLocation } from 'react-router';

import { useSelectorActiveChain } from 'components/hooks';
import { chainsMap } from 'config/constants';
import { getDashboardUrl } from 'reduxState/markets/listed/listedMarketsUtils';
import { useSelector } from 'reduxState/store';

function DashboardIndexRedirect() {
  const { activeChain } = useSelectorActiveChain();
  const { search } = useLocation();
  const defaultMarket = useSelector(
    state => state.markets.listedMarkets.defaultMarket
  );
  const currentMarketPair = useSelector(
    state => state.markets.currentMarket.pair
  );

  // const location = useRouterLocation();
  // const { ethereumChain } = chainsMap;
  // All legacy paths will redirect to new ETH market pages
  // if (location.pathname.startsWith('/trade/')) {
  //   if (activeChain !== ethereumChain.code) {
  //     setTimeout(() => {
  //       console.log('Switching from legacy /trading to chain specific');
  //       changeChainWithAppReload(ethereumChain.code);
  //     });
  //     return null;
  //   }
  //   return <Redirect to={`/${ethereumChain.shortCode}${location.pathname}`} />;
  // }

  if (defaultMarket === undefined) {
    // Loading...
    return null;
  }

  const dashboardUrl = getDashboardUrl(
    activeChain,
    currentMarketPair,
    defaultMarket || chainsMap[activeChain].fallbackDefaultMarket,
    undefined,
    search
  );

  if (dashboardUrl) {
    return <Navigate to={dashboardUrl} replace />;
  }

  // We need to wait until default market is initialized
  return null;
}

export default DashboardIndexRedirect;
